//fetch all node instances
var node;
var lsModelId;
var loArrOfContextIds;
function FetchAllNodeInstances(pOverlaySrv, pModelId, pNode) {

   // var data = FetchNodeInstances(pOverlaySrv, pModelId, pNode, [], SEARCHTYPE_ALL);
    var data = FetchNodeInstances(pOverlaySrv, pModelId, pNode, [], 0);
    return data;
}

//fetch node instances based on criteria
function FetchNodeInstances(pOverlaySrv, pModelId, pNode, pContext, pSearchType) {

    var loNodeId = pOverlaySrv.GetNodeIdbyUniqueName(pModelId, pNode).data;
    if (loNodeId == null) return;

    var data = [];
    var ArrContextId = JSON.stringify(pContext);
    var InstanceStatusValues = pOverlaySrv.GetNodeValueInstances(pModelId, loNodeId, ArrContextId, pSearchType);

    if (InstanceStatusValues.success == true) {

        InstanceStatusValues.data.forEach(function (d) {

            var nodename = "";
            node = {}
            node["id"] = d.Id;

            var i = 0;
            var keys = Object.keys(d.Contexts);
            for (i = 0; i < keys.length; i++) {
                if (i > 0)
                    nodename += ', ';
                nodename += d.Contexts[keys[i]];
            }

            //if (d.Contexts[Object.keys(d.Contexts)[0]] != d.StatusValue)

            node["context"] = nodename;
            node["contextIds"] = keys;
            node["statusvalue"] = d.StatusValue;

            data.push(node);
        });
    }

    return data;

}


function SetPrimaryAttribute(pOverlaySrv, pModelId, pNodeId, pStatusValue, pContext, pIsContextLabel, pId) {
    var liId;

    if (pIsContextLabel) {
        //add context label
        if (pId == null || pId == undefined)
            liId = pOverlaySrv.AddContextLabel(pModelId, pNodeId, pStatusValue).data;
        else 
            liId = pOverlaySrv.AddContextLabel(pModelId, pNodeId, pStatusValue).data; //liId = pOverlaySrv.AddContextLabelEx(pModelId, pNodeId, pStatusValue,pId).data;
    }
    else {
        //set node value
        pOverlaySrv.SetNodeValue(pModelId, pNodeId, pContext, pStatusValue);

        //var loRetval = pOverlaySrv.GetNodeValueInstances(lsModelId, pNodeId, loArrOfContextIds, SEARCHTYPE_EXACH_MATCH);
        var loRetval = pOverlaySrv.GetNodeValueInstances(lsModelId, pNodeId, loArrOfContextIds, 0);
        if (loRetval.data.length > 0) {
            //liId = pOverlaySrv.SetNodeValue(pModelId, pNodeId, pStatusValue);
        }
    }

    return liId;
}

//set all the attributes of a defined entity cluster
// { pJsonArrayofAttributeValues } : [{value: {AttributeValue}, context: {AttributeContext}, node: {NodeId} }, .... , {value: {AttributeValue}, context: {AttributeContext}, node: {NodeId} }]
function SetAttributes(pOverlaySrv, pModelId, pJsonArrayofAttributeValues) {

    var loArrOfNodeValues = [];

    pJsonArrayofAttributeValues.forEach(function (attributeObj) {
        var loNodeId = pOverlaySrv.GetNodeIdbyUniqueName(pModelId, attributeObj.node).data;

        var loArrContexIds = attributeObj.context;
        var lsArrContexIds = JSON.stringify(loArrContexIds);

        var loNodeValue = {};
        loNodeValue["nodeId"] = loNodeId;
        loNodeValue["ContextIds"] = lsArrContexIds;
        loNodeValue["newValue"] = attributeObj.value;

        loArrOfNodeValues.push({ "ActiveNode": loNodeValue });

    })

    pOverlaySrv.SetNodeValueExtended(pModelId, loArrOfNodeValues);


}

function SetIdentificationAttribute(pOverlaySrv, pModelId, pNodeId, pStatusValue, pContext) {
    //
}
function GetPrimaryAttribute(pOverlaySrv, pModelId, pNode, pContext, pSearchType) {

    var loNodeId = pOverlaySrv.GetNodeIdbyUniqueName(pModelId, pNode).data;
    if (loNodeId == null) return;

    var data = [];
    var lArrCtx = JSON.stringify(pContext);
    var InstanceStatusValues = pOverlaySrv.GetNodeValueInstances(pModelId, loNodeId, lArrCtx, pSearchType);

    if (InstanceStatusValues.success == true) {

        InstanceStatusValues.data.forEach(function (d) {

            var nodename = "";
            node = {}
            node["id"] = d.Id;

            var i = 0;
            var keys = Object.keys(d.Contexts);
            for (i = 0; i < keys.length; i++) {
                if (i > 0)
                    nodename += ', ';
                nodename += d.Contexts[keys[i]];
            }

            //if (d.Contexts[Object.keys(d.Contexts)[0]] != d.StatusValue)

            node["context"] = nodename;
            node["contextIds"] = keys;
            node["statusvalue"] = d.StatusValue;

            data.push(node);
        });
    }

    return data;
}
function GetAttribute(pOverlaySrv, pModelId, pNode, pContext) {
    
   // var Attributes = GetPrimaryAttribute(pOverlaySrv, pModelId, pNode, pContext, SEARCHTYPE_PARTIAL_MATCH);	
    var Attributes = GetPrimaryAttribute(pOverlaySrv, pModelId, pNode, pContext, 1);	
    return (Attributes.length > 0) ? Attributes[0]["statusvalue"] : "";
	
}

function GetRefAttribute(pOverlaySrv, pModelId, pNode, pContext, pReturnAll) {
    
    //var Attributes = GetPrimaryAttribute(pOverlaySrv, pModelId, pNode, pContext, SEARCHTYPE_PARTIAL_MATCH);	
    var Attributes = GetPrimaryAttribute(pOverlaySrv, pModelId, pNode, pContext, 1);	
    var lArrCtx = (Attributes.length > 0) ? Attributes[0]["contextIds"] : [];
	
    let intersection = (pReturnAll === true) ? lArrCtx : pContext.filter(x => lArrCtx.includes(x));
	
    return intersection;
}

function GetIdentificationAttributes(pOverlaySrv, pModelId, pNodeId, pContext, pSearchType) {
    //
}

function EraseInstance(pOverlaySrv, pModelId, pNode, pContext) {

    var loNodeId = pOverlaySrv.GetNodeIdbyUniqueName(pModelId, pNode).data;
    if (loNodeId == null) return;

    pOverlaySrv.EraseInstance(pModelId, loNodeId, JSON.stringify(pContext));

}
export  {
    FetchAllNodeInstances,
    FetchNodeInstances,
    SetPrimaryAttribute,
    SetAttributes,
    SetIdentificationAttribute, 
    GetPrimaryAttribute,
    GetAttribute,
    GetRefAttribute,
    GetIdentificationAttributes,
    EraseInstance

}



// WEBPACK FOOTER //
// ./src/components/Utils/js-bridge/overlayutil.js